import React, { useState } from "react"
import {
  emailValidator,
  passwordValidator,
  usernameValidator,
} from "../../util"
import { useDispatch } from "react-redux"
import { updateUser } from "../../store/users"
import "../styles/AccountForm.css"

function AccountForm({ user }) {
  const dispatch = useDispatch()
  if (!user) {
    return <div>Loading...</div>
  }
  const [isDisabled, setIsDisabled] = useState(true)
  const [formErrors, setFormErrors] = useState({
    username: false,
    email: false,
    password: false,
    confirmPassword: false,
  })

  const [formData, setFormData] = useState({
    username: user.username,
    email: user.email,
    password: "",
    confirmPassword: "",
    avatar: user.avatar,
    createdAt: user.createdAt,
    updatedAt: user.updatedAt,
    id: user.id,
  })

  const handleSaveClick = (event) => {
    event.preventDefault()
    console.log(formData)
    dispatch(
      updateUser({
        id: formData.id,
        data: {
          username: formData.username,
          email: formData.email,
          password: formData.password,
          avatar: formData.avatar,
        },
      })
    )
    setIsDisabled(true)
  }

  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    })
    validateForm(event)
  }

  const validateForm = (event) => {
    const { username, email, password, confirmPassword } = formData
    let passwordToCheck =
      event.target.name === "confirmPassword"
        ? event.target.value
        : confirmPassword
    const errors = {
      username:
        event.target.name === "username"
          ? !usernameValidator(event.target.value)
          : !usernameValidator(username),
      email: !emailValidator(email),
      password:
        password !== "" || confirmPassword !== ""
          ? !passwordValidator(password)
          : false,
      confirmPassword:
        password !== "" || confirmPassword !== ""
          ? password !== passwordToCheck
          : false,
    }
    setFormErrors(errors)
    setIsDisabled(Object.values(errors).some((error) => error === true))
  }

  const onFileChange = (event) => {
    const reader = new FileReader()
    reader.readAsDataURL(event.target.files[0])
    reader.onload = () => {
      setFormData({ ...formData, avatar: reader.result })
    }
    reader.onerror = function (error) {
      console.log("Error: ", error)
    }
    setIsDisabled(false)
  }

  return (
    <div className="account-form-container">
      <div className="account-form-card-container">
        <div className="card-body">
          <h2 className="card-title">
            <div className="welcome-user-text">Welcome {formData.username}</div>
          </h2>
          <div className="flex flex-row">
            <span className="edit-account-instructions">
              Edit Your Account & Press Save
            </span>
            <div className="avatar self-end">
              <div className="account-form-avatar">
                <img src={formData.avatar} alt={formData.username} />
              </div>
            </div>
          </div>
          <div>Joined: {new Date(formData.createdAt).toLocaleDateString()}</div>

          <form
            className="account-form"
            onSubmit={(event) => handleAccountEdit(event, formData)}
          >
            <div className="form-control">
              <label className="label">
                <span className="label-text">Username</span>
              </label>
              <input
                type="text"
                placeholder="Username"
                className="input"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
              />
              {formErrors.username && (
                <div className="text-error text-xs">
                  Must Be 8-30 Characters Long & No Special Chacters
                </div>
              )}
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Email</span>
              </label>
              <input
                type="text"
                placeholder="Email"
                className="input"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {formErrors.email && (
                <div className="text-error text-xs">Email Must Be Valid</div>
              )}
            </div>
            <div className="flex flex-row">
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Change Password</span>
                </label>
                <input
                  type="password"
                  placeholder="Password"
                  className="input"
                  autoComplete="newpassword"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                />
                {formErrors.password && (
                  <div className="text-error text-xs">
                    Must Be 8-15 Characters Long & No Special Characters
                  </div>
                )}
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text">Confirm New Password</span>
                </label>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  autoComplete="newpassword"
                  className="input"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                />
                {formErrors.confirmPassword && (
                  <div className="text-error text-xs">Passwords Must Match</div>
                )}
              </div>
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Profile Image</span>
              </label>
              <input
                type="file"
                className="image-input"
                onChange={onFileChange}
              />
            </div>

            <button
              className="btn-save"
              disabled={isDisabled}
              onClick={handleSaveClick}
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AccountForm
